/* import __COLOCATED_TEMPLATE__ from './standard-modal-header-with-link.hbs.js'; */
/**
## StandardHeaderWithLink

Displays a modal header with a link in the top-right corner.

### Parameters
@param {String} title - The title for the header
@param {Object} link - Hash object describing the text and the action of the link:
@param {String} link.text - Display text of the link
@param {Action} link.action - Closure action to execute when the link is clicked.
@param {String} link.href - Href to link to. If this is present it will take precedence over the action.

Sass dependencies at: `components/modals/_standard-header-with-link.sass`
*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'header',
  classNames: ['modal-layout__header', 'modals__standard-header-with-link']
});